import React from "react";
import Header from "../core/Header";
import Footer from "../core/Footer";

const Stacks = () => {
  return (
    <div>
      <Header />
      <div className="container py-4">
        <h3 className="pb-2">Stacks Blockchain App</h3>
        <p className="text-muted">
          Simple local demo for blockchain security monitoring.
        </p>

        <div className="card p-3 mb-3">
          <h6>Network Status</h6>
          <p className="mb-0">Mainnet connectivity: Healthy</p>
        </div>

        <div className="card p-3 mb-3">
          <h6>Recent Signals</h6>
          <ul className="mb-0">
            <li>Unusual transaction volume alert</li>
            <li>Wallet reputation check completed</li>
            <li>Smart contract event stream active</li>
          </ul>
        </div>

        <div className="card p-3">
          <h6>Security Controls</h6>
          <ul className="mb-0">
            <li>Address risk scoring</li>
            <li>Transaction anomaly detection</li>
            <li>Rule-based alerting pipeline</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Stacks;
